"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressCheckoutWidgetService = void 0;
var apiRoutes_1 = require("../../utils/apiRoutes");
var Base_1 = require("../Base");
var ExpressCheckoutWidgetService = /** @class */ (function (_super) {
    __extends(ExpressCheckoutWidgetService, _super);
    function ExpressCheckoutWidgetService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExpressCheckoutWidgetService.prototype.fetchWidgetSettings = function (useNewApi) {
        return this.request({
            url: (0, apiRoutes_1.expressCheckoutWidgetSettingsApiUrl)(useNewApi),
            method: 'get',
        });
    };
    return ExpressCheckoutWidgetService;
}(Base_1.BaseService));
exports.ExpressCheckoutWidgetService = ExpressCheckoutWidgetService;
//# sourceMappingURL=index.js.map